import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToast } from '../Contexts/ToastContext';

const MISSING_AGGREGATE_ERROR = 'This processed timesheet is not an aggregate timesheet.';
const REDIRECT_INFO = 'You are being redirected to the aggregate processed timesheet.';

const buildAggregatePtsUrl = (pathname, search, aggregatePTSId) => {
    const match = pathname.match(/^(\/processed-timesheets\/)([^/]+)(.*)$/);
    const nextPath = match
        ? `${match[1]}${aggregatePTSId}${match[3]}`
        : `/processed-timesheets/${aggregatePTSId}`;
    return `${nextPath}${search}`;
};

const useRedirectToAggregatePts = ({
    processedTimesheetId,
    timesheetDetailsData,
    isLoading = false,
    isFetching = false,
}) => {
    const { replace } = useHistory();
    const { pathname, search } = useLocation();
    const { showInfoToast, showErrorToast } = useToast();
    const lastHandledRef = useRef('');

    useEffect(() => {
        if (isLoading || isFetching || !timesheetDetailsData) return;

        const { aggregatePTSId, splitByWorkLocation } = timesheetDetailsData;
        const signature = `${processedTimesheetId}:${aggregatePTSId ?? ''}:${Boolean(
            splitByWorkLocation
        )}`;
        if (lastHandledRef.current === signature) return;
        lastHandledRef.current = signature;

        if (!aggregatePTSId) {
            if (splitByWorkLocation) {
                showErrorToast(MISSING_AGGREGATE_ERROR);
            }
            return;
        }

        if (Number(aggregatePTSId) !== Number(processedTimesheetId)) {
            showInfoToast(REDIRECT_INFO);
            replace(buildAggregatePtsUrl(pathname, search, aggregatePTSId));
        }
    }, [
        isLoading,
        isFetching,
        timesheetDetailsData,
        processedTimesheetId,
        pathname,
        search,
        replace,
        showInfoToast,
        showErrorToast,
    ]);
};

export default useRedirectToAggregatePts;
